import * as types from "../constants/instrumentListConstants";
import * as commType from "../constants/commonConstants";
import * as tradepanelActions from "./tradepanelActions";
import { CommonActions } from "./commonActions";
import { LSPATH, WSRATEPATH } from "./../constants/index";
import Socket from "../utils/socket";
import { LightstreamerClient, Subscription } from "lightstreamer-client-web";

let rateSocket;
let rateWebSocket;
let closedFromClient = false;
let socketConnection = false;
const SUB_MODE = "MERGE";
const ADAPTER_NAME = "RATES";
const ADAPTER_SET = "FORWARDS";
const SNAPSHOT_REQ = "yes";

let channel = new BroadcastChannel("rates");
const subscribedPairs = new Map();

// function to be called for sending HB
function sendHeartbeat(ws) {
  let obj = {};
  obj.MT = 20;
  ws.send(JSON.stringify(obj));
  socketConnection = true;

  // setTimeout(() => {
  //   let obj = JSON.parse(localStorage.getItem("trdPnlCmdty"));
  //   let tempArray = obj.array;
  //   if (tempArray.length !== 0) {
  //     for (let i = 0; i <= tempArray.length; i++) {
  //       subscribeTier(tempArray[i], true);
  //     }
  //   }
  // }, 2000);
}

// function to be called after opening
function callOnOpening() {
  return [sendHeartbeat];
}

// function to be called after receiving messages
function callOnMessage(dispatch, event) {
  if (event.data !== "Invalid token") {
    channel.postMessage(JSON.parse(event.data));
    // use localstorage for storing rates for safari older versions
    const browserVersion = navigator.userAgent
      .split(" ")
      ?.filter((d) => d?.includes("Version/"))[0]
      ?.split("/")[1];
    if (parseFloat(browserVersion) < 15.3) {
      localStorage.setItem("popupRates", event.data);
    }
    dispatch(updateSocketData(event));
    const msg = JSON.parse(event.data);
    const BCM = msg.BCM;
    if (BCM !== undefined) {
      if (BCM === "701") {
        const obj = JSON.parse(localStorage.getItem("trdPnlCmdty"));
        let tempArray = obj.array;
        if (tempArray.length !== 0) {
          for (let i = 0; i <= tempArray.length; i++) {
            subscribeTier(tempArray[i], true);
          }
        }
      }
    }
  }
}

// function to be called after disconnection
function callOnDisconnect(dispatch) {
  dispatch(updateStatus());
  dispatch(clearHeartRateInterval());
  dispatch(tradepanelActions.killSessionTrader("Session Expired", false));
  dispatch(tradepanelActions.killlogout());
}

// functions to be called after rate and order reconnection
function callOnReconnect(dispatch) {
  socketConnection = false;
  dispatch(updateStatus());
}

// new socket connection logic
export function loadSocket(dispatch) {
  // need to declare constants here to get non-null values
  const USER = JSON.parse(localStorage.getItem("user"));
  const PLATFORM = localStorage.getItem("platform");

  // check if user data exists
  if (USER === null) {
    dispatch(sessionTimeout());
  } else {
    // establish websocket connection
    rateSocket = new Socket();
    const rateWSParams = {
      url: WSRATEPATH + "/rate/trader",
      params: [
        "neo-ws-protocol",
        "UID|" + USER.id,
        "token|" + USER.authToken,
        "platform|" + PLATFORM,
        "SID|" + USER.sid,
        "CID|" + USER.location,
      ],
    };
    rateWebSocket = rateSocket.connectSocket(
      rateWSParams,
      dispatch,
      callOnOpening,
      callOnMessage,
      callOnDisconnect,
      callOnReconnect
    );
  }
}

export function loadInstrumentList() {
  return (dispatch) => {
    dispatch(
      CommonActions.handleAPICall(
        data,
        "/instrument_list",
        types.LOAD_INSTRUMENT_LIST,
        "GET"
      )
    );
  };
}
export function updateSocketData(message) {
  return {
    type: types.UPDATE_SOCKET_DATA,
    message,
  };
}
export function subscribeTier(commodity, flag) {
  try {
    socketConnection = flag;
    if (socketConnection === true && rateWebSocket) {
      rateWebSocket = rateSocket.getSocket();
      rateWebSocket.send(JSON.stringify({ MT: "0", sub: commodity }));
    } else {
      setTimeout(() => {
        if (closedFromClient === false) {
          subscribeTier(commodity, socketConnection);
        }
      }, 100);
    }
  } catch (e) {
    subscribeTier(commodity, socketConnection);
  }
  return {
    type: types.SUBSCRIBE_TIER,
  };
}
export function clearHeartRateInterval() {
  rateSocket?.resetSocket();
  return {
    type: commType.CLEAR_KILL_SESSION,
  };
}
export function unsubscribeTier(commodity) {
  try {
    if (localStorage.getItem("logoutClose") !== "true") {
      if (socketConnection === true && rateWebSocket) {
        rateWebSocket = rateSocket.getSocket();
        rateWebSocket.send(JSON.stringify({ MT: "0", usub: commodity }));
      } else {
        setTimeout(() => {
          if (closedFromClient === false) {
            subscribeTier(commodity);
          }
        }, 100);
      }
    }
    return {
      type: types.UNSUBSCRIBE_TIER,
    };
  } catch (e) {
    console.log(e);
  }
}

export function updateStatus() {
  return {
    type: types.UPDATE_STATUS,
  };
}
export function updateFlag(flag) {
  return {
    type: types.SOCKET_FLAG,
    flag,
  };
}
export function loadSocketData() {
  return (dispatch) => {
    dispatch({
      type: types.LOAD_SOCKET_DATA,
      socketData: loadSocket(dispatch),
    });
  };
}

export function closeSocketCon() {
  if (rateSocket) {
    closedFromClient = true;
    rateSocket.resetSocket();
  }
}

export function reconnectRateSocketCon() {
  closeSocketCon();
  loadSocketData();
}

export function closeSocketData() {
  return {
    type: types.CLOSE_SOCKET_DATA,
    socketData: closeSocketCon(),
  };
}
export function updateAccBal(acccode) {
  let data = `acccode=${acccode}`;
  return (dispatch) => {
    dispatch(
      CommonActions.handleAPICall(
        data,
        "/loadAccount",
        types.LOAD_ACCOUNT,
        "GET"
      )
    );
  };
}
//MArgin function
export function loadAccBalData(accBal, instList, neocom) {
  return {
    type: types.LOAD_ACCBAL,
    accBal,
    instList,
    neocom,
  };
}
export function loadMrginCal() {
  return {
    type: types.LOAD_MARGINCOMPONENT,
  };
}
export function resetStateSocket() {
  return {
    type: types.RESET_STATE_SOCKET,
  };
}
export function refreshProximity() {
  //console.log("refreshProximity socketData "+JSON.stringify(socketData));
  return {
    type: types.REFRESH_PROXIMITY,
  };
}

// reset tenordata fd#27683

export function resetTenorData() {
  return {
    type: types.RESET_TENOR_DATA,
  };
}

// forwards

export function getTenorValDate(data) {
  return (dispatch) => {
    dispatch(
      CommonActions.handleAPICall(data, "/getTenors", types.GET_VAL_DATE, "GET",data)
    );
  };
}

// swaps

export function getSwapLocation(data) {
  return (dispatch) => {
    dispatch(
      CommonActions.handleAPICall(data, '/getAccLocShrtnameAndCode', types.GET_SWAP_LOCATIONS, "POST",data)
    );
  };
}

/**
 * Callback for handling data recieved
 * @callback handleData
 */

/**
 * Handle messages received for lightstreamer stream
 * @param {Function} dispatch redux dispatch function
 * @param {Object} data data recived from lighstreamer stream
 * @param {handleData} callbackFunction for handling the data received
 * @param {string} streamName unique stream name based on user specific parameters
 */
export function callOnMessageLS(dispatch, data, callbackFunction, streamName) {
  dispatch(updateForwardsData(data, callbackFunction, streamName));
}
 
/**
 * Subscribe to LS rates
 * @param {handleData} updateFWDStates updates rates on UI and handles timer
 * @param {string} streamName unique stream name based on user specific parameters
 * @param {Array} subscription array containing array of items and fields to be subscribed
 * @returns redux action for subscription
 */
export function subscribeFWDRates(updateFWDStates, streamName, subscription, adapterName="RATES" , fieldName="fwdRate") {
    return (dispatch) => {
        const client = new LightstreamerClient(LSPATH, ADAPTER_SET);
        const USER = JSON.parse(localStorage.getItem('user'))
        const connUsername = USER?.location
        client.connectionDetails.setUser(connUsername);
        const PLATFORM = localStorage.getItem("platform");
        const UID = USER?.id;
        const connPassword = `${UID}##${PLATFORM}`;
        client.connectionDetails.setPassword(connPassword);
        const subscriptionObj = new Subscription(SUB_MODE);
        subscriptionObj.setDataAdapter(adapterName);
        subscriptionObj.setRequestedSnapshot(SNAPSHOT_REQ);
        subscriptionObj.setItems(subscription[0]);
        subscriptionObj.setFields(subscription[1]);
        subscriptionObj.addListener({
            onItemUpdate: (obj)=> {
                const fwdData = obj.getValue(fieldName)
                if(fwdData) {
                    callOnMessageLS(dispatch, fwdData, updateFWDStates, streamName);
                }
            }
        });
        client.subscribe(subscriptionObj);
        client.connect();
        const subscriptionDetails = {
            client,
            subscriptionObj
        }
        subscribedPairs.set(streamName, subscriptionDetails)
        return {
            type : types.SUBSCRIBE_FWD_RATES,
            payload : { updateFWDStates }
        }
    }
}
  
/**
 * Redux action to update FWD data in reducer
 * @param {Object} fwdData rates JSON received from stream
 * @param {handleData} updateFWDStates updates rates on UI and handles timer
 * @param {Array} subscription array containing array of items and fields to be subscribed
 * @returns redux action for updating data in reducer
 */
export function updateForwardsData(fwdData, updateFWDStates, streamName) {
    const forwardsPayload = {
      updateFWDStates,
      streamName,
      fwdData
    };
    return {
      type: types.UPDATE_FORWARDS_DATA,
      payload: forwardsPayload,
    };
  };

/**
 * Redux action to unsubscribe stream and disconnect lightstreamer
 * @param {Map} streamName subscription map containing streamName as key and subscription data as value
 * @returns redux action for unsubscription
 */
export function unsubscribeFWDRates(streamName) {
    const { client, subscriptionObj } = subscribedPairs.get(streamName);
    client.unsubscribe(subscriptionObj);
    client.disconnect()
    return {
        type: types.UNSUBSCRIBE_FWD_RATES,
        payload: { streamName },
    };
}
